function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.4 16a8 8 0 100-16 8 8 0 000 16zm-3.97-4.827a.5.5 0 00.795.206l7-6a.5.5 0 10-.65-.759l-7 6a.5.5 0 00-.144.553z"
});

function SvgUnpublish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "#9F9FA4",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgUnpublish;